import { render } from "./PartnersByTierChart.vue?vue&type=template&id=528c5c6a&scoped=true"
import script from "./PartnersByTierChart.vue?vue&type=script&lang=js"
export * from "./PartnersByTierChart.vue?vue&type=script&lang=js"

import "./PartnersByTierChart.vue?vue&type=style&index=0&id=528c5c6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-528c5c6a"

export default script